import { useState } from "react";

function LeadForm() {
 const [form, setForm] = useState({
  name: "",
  phone: "",
  email: "",
  referral: "",   // ✅ added
  agree: false,
});

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    // 🔥 PHONE VALIDATION
    if (name === "phone") {
      // Allow only digits
      if (!/^\d*$/.test(value)) {
        setPhoneError("Phone number must contain digits only.");
        return;
      }

      // Max length 13
      if (value.length > 13) return;

      setPhoneError("");
    }

    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!form.name || !form.phone || !form.email) {
      setMessage("Please fill all fields.");
      return;
    }

    // 🔥 FINAL VALIDATION BEFORE SUBMIT
    if (!/^\d{10,13}$/.test(form.phone)) {
      setPhoneError("Enter a valid phone number (10–13 digits).");
      return;
    }

    if (!form.agree) {
      setMessage("Please accept Terms & Privacy Policy.");
      return;
    }

    try {
      setLoading(true);

      const response = await fetch("/api/leads", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: form.name,
          phone: form.phone,
          email: form.email,
          referral: form.referral,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("✅ Submitted Successfully!");
        setForm({
          name: "",
          phone: "",
          email: "",
          referral: "", 
          agree: false,
        });
        setPhoneError("");
      } else {
        setMessage(data.error || "Submission Failed.");
      }
    } catch (error) {
      setMessage("Server Error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="lead-section">
      <div className="lead-box">

        <h2>Start Your Journey 🚀</h2>
        <p>Join Codeion & become job-ready in 6 months</p>

        {message && <div className="lead-message">{message}</div>}

        <form onSubmit={handleSubmit}>

          <table className="lead-table">
            <tbody>

              <tr>
                <th>Full Name</th>
                <td>
                  <input
                    type="text"
                    name="name"
                    placeholder="Enter Full Name"
                    value={form.name}
                    onChange={handleChange}
                  />
                </td>
              </tr>

              <tr>
                <th>Phone</th>
                <td>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Enter Phone Number"
                    value={form.phone}
                    onChange={handleChange}
                    maxLength={13}
                  />
                  {phoneError && (
                    <div className="input-error">{phoneError}</div>
                  )}
                </td>
              </tr>

              <tr>
                <th>Email</th>
                <td>
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter Email Address"
                    value={form.email}
                    onChange={handleChange}
                  />
                </td>
              </tr>

              <tr>
  <th>Referral Code</th>
  <td>
    <input
      type="text"
      name="referral"
      placeholder="Enter referral code (optional)"
      value={form.referral}
      onChange={handleChange}
    />
  </td>
</tr>

              <tr>
                <td colSpan="2" className="agree-row">
                  <label>
                    <input
                      type="checkbox"
                      name="agree"
                      checked={form.agree}
                      onChange={handleChange}
                    />
                    I agree to Terms & Privacy Policy
                  </label>
                </td>
              </tr>

              <tr>
                <td colSpan="2">
                  <button type="submit" disabled={loading}>
                    {loading ? "Submitting..." : "Get Started Free →"}
                  </button>
                </td>
              </tr>

            </tbody>
          </table>

        </form>
      </div>
    </section>
  );
}

export default LeadForm;